import { render, staticRenderFns } from "./updateTransitionDialog.vue?vue&type=template&id=2bcb3eab&scoped=true&"
import script from "./updateTransitionDialog.vue?vue&type=script&lang=js&"
export * from "./updateTransitionDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateTransitionDialog.vue?vue&type=style&index=0&id=2bcb3eab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb3eab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardTitle,VContainer,VDialog,VRow,VSpacer,VTextField})
